<template>
      <v-card-text class="mt-4">
          <p>
            <strong
              >Privacy and Conditions for ThinkAir Digital Outreach
            </strong>
          </p>
          <p>
            Once you have received a confirmation email from us which will
            include your unique access code, your booking and subsequent access
            to the digital content is confirmed. ThinkAir reserves the right
            to make changes to any funded booking or access code.
          </p>
          <p>
            Please do not share your unique access code with other users; the
            code is single use and can only be used once. If you believe someone
            has redeemed your code please contact us on
            <a href="mailto:info@techniquest.org">info@techniquest.org</a>
            quoting the code in question, the ThinkAir team will then cancel
            the associated access and issue you a new one if necessary.
          </p>
          <p>
            The digital content can be shown as many times as required in the
            booked school for the duration of the content (7 consecutive days).
          </p>
          <p>
            The downloadable resources can only be shared with colleagues in the
            booked school, please do not share them with colleagues in other
            schools or external groups.
          </p>
          <p>
            Cancellations and refunds can only be granted and issued if the
            unique code associated with the request has not been redeemed.
            Please provide the ThinkAir team with the code when you request
            cancellation and they will cross check the code before confirming
            the refund.
          </p>
          <p>
            <strong
              >Privacy Policy for ThinkAir Digital Outreach</strong
            >
          </p>
          <p>
            ThinkAir is committed to being transparent about how it handles
            your personal information, to protecting the privacy and security of
            your personal information and to meeting its data protection
            obligations under the General Data Protection Regulation (the GDPR)
            and the Data Protection Act 2016.
          </p>
          <p>
            When an individual has access to the Digital Outreach platform,
            personal data will be obtained before the content is accessible.
            This data includes but is not limited to; 
            <ul>
              <li>Name of teacher </li>
              <li>Email address</li>
              <li>Information about the group the content is being delivered to</li>
            </ul>
          </p>

          <p>This information is necessary for reporting purposes.</p>
          <p>
            This data is held in our outreach platform, supported by Vindico and
            can only be accessed by staff members with password protected
            accounts. There are also different levels of authorisation within
            the system so some can see/do more than others. Data is held
            indefinitely as information can be used for future bookings and for
            having a booking history with the client. Please contact us if you
            wish to be removed.
          </p>
          <p>
            An opt-in to marketing is also displayed on the platform. Your
            information is not shared with any company outside of ThinkAir
            and is only accessible within the Operations and Marketing
            department of ThinkAir. Please contact us if you wish to be
            removed. Full details of ThinkAir data protection procedures
            can be found here:
            <a href=" https://www.techniquest.org/terms-conditions/privacy-policy/" target="_blank"> https://www.techniquest.org/terms-conditions/privacy-policy/</a>
          </p>
          <p>
            If you have any questions about this privacy notice or how we handle
            your personal information, please contact <a href="mailto:info@techniquest.org">info@techniquest.org</a>.
          </p>
        </v-card-text>

</template>

<script>
export default {
    name: 'PrivacyTermsConditions'
}
</script>